import { render, staticRenderFns } from "./SetDefaultBank.vue?vue&type=template&id=471bc270&lang=pug"
import script from "./SetDefaultBank.vue?vue&type=script&lang=js"
export * from "./SetDefaultBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports